<template>
  <div class="content">
    <p class="title">
        <el-breadcrumb separator-class="el-icon-arrow-right color3">
            <el-breadcrumb-item>系统管理</el-breadcrumb-item>
            <el-breadcrumb-item>会议管理</el-breadcrumb-item>
        </el-breadcrumb>
    </p>
    <div class="build-CURD">
      <div class="build-bar">
       <div class="display">
           <span>角色名：</span>
        <el-input placeholder="请输入sn" v-model=" sn"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
       </div>
        <el-button type="primary" class="add-user" @click="addRow()">ipad添加</el-button>
      </div>
      <div class="build-table">
        <el-table
          :default-sort="{prop: 'date', order: 'descending'}"
          :data="tableDataEnd"
          border
          height="100%"
          style="width: 100%;"
        >
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>
           <el-table-column label="设备号">
            <template slot-scope="scope">
              <a>{{ scope.row.sn}}</a>
            </template>
          </el-table-column>
          <el-table-column label="组织名称">
            <template slot-scope="scope">
              <a>{{ scope.row.officeName}}</a>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
          <!-- 新增窗口 -->
        </el-table>
        <!-- 分页展示 --> 
      </div>
      <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
              style="padding:10px"
        ></el-pagination>
    </div>
   <!-- 新增 -->
       <el-dialog
                :title="addTitle"
                :visible.sync="addFormVisible"
                center
                width="800px"
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
              >
                <el-form
                  :model="addForm"
                  label-width="200px"
                  ref="addForm"
                  label-position="right"
                  :rules="rules"
                >
                  <el-form-item label="设备sn">
                     <el-input
                      v-model="addForm.sn"
                      autocomplete="off"
                      style="width:217px"
                    ></el-input>
                  </el-form-item>
                   <el-form-item label="组织" prop="type">
                    <el-select v-model="addForm.officeId" placeholder="请选择">
                      <el-option
                        v-for="item in office"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="描述:" prop="remarks">
                    <el-input
                      type="textarea"
                      :rows="2"
                      v-model="addForm.remarks"
                      autocomplete="off"
                      style="width:217px;height:200px"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="addFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                </div>
              </el-dialog>
  </div>
</template>

<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      labelPosition: 'right',
      addLoading: false,
      addForm: {
        //form表格属性
        id: '',
        officeId:'',
        sn:'',
        remarks:'',
        entId:''
      },
      addTitle: '', //弹出框标题
      // editForm: [],
      addFormVisible: false,
      roleType: '', //所选下拉框数据
      groups: [], //企业或者项目（根据所选端）
      checkData: [], //展示已经选中的内容，["id","id"]web端
      tableDataName: '',
      tableDataEnd: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      filterTableDataEnd: [],
      flag: false,
      dataText: '数据加载中...',
       sn:'',
      rules: {
        name: [{ required: true, message: '请输入角色名', trigger: 'blur' }]
      },
      office: [], //组织机构
    }
  },
  created() {},
  mounted() {
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.groupId = this.$store.state.groupId
    }
    this.getData()
    // this.getMenu();
    // this.getAppMenu()
    // this.zidian()
  },
  methods: {
  
    // 搜索数据
    doFilter() {
      this.currentPage = 1
      this.currentChangePage()
      this.flag = true
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      if (!this.flag) {
        this.currentChangePage()
      } else {
        this.currentChangePage()
      }
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 获取数据
    getData() {
      var option = {
        entId: this.groupId,
        pageNum:this.currentPage,
        pageSize:this.pageSize,
        sn:this.sn
      }
      var that = this
      //myHttp.getRoleListByGroupId(option).then(
      myHttp.pageInfoipad(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.ipadPageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              //list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
              list[i].index = i + 1
            }
            that.tableDataEnd = list
            //that.totalItems = resp.data.data.pageInfo.total||0;
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    // 组织机构
    getoffice() {
      var that = this
      // getofficePageList
      myHttp
        .getofficePageList({
          entId: this.groupId,
        })
        .then(
          function (resp) {
            if (resp.data.code == '200') {
              that.office = resp.data.data.officeList || []
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '服务器出错'
            }
          },
          function () {}
        )
    },


    // 编辑数据
    handleEdit(index, row) {
      this.getoffice()
      this.addTitle = '角色修改'
      this.addFormVisible =true
      this.addForm.id =row.id,
      this.addForm.remarks =row.remarks
      this.addForm.officeId =row.officeId
      this.addForm.sn =row.sn
      this.addForm.entId=this.groupId
    },
    //获取项目信息
    getGrounpName: function(id) {
      var list = this.groups
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].groupId) {
          result = list[i].groupName
        }
      }
      return result
    },
    //获取端名称
    getUserTypeName(id) {
      var list = this.userTypes
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    // 删除数据
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          myHttp
            .deleteInfoipad({
              id: row.id
            })
            .then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message({
                    type: 'success',
                    message: '删除成功!'
                  })
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
        })
        .catch(err => {
          that.$message({
            type: 'error',
            message: err
          })
        })
    },
    // 新增数据
    addRow() {
      this.getoffice()
      this.addTitle = '新增ipad'
      this.addFormVisible=true;
      this.addForm={
        id: '',
        officeId:'',
        sn:'',
        describe:'',
        entId:this.groupId
      }
    },
    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.addForm.id == '') {
            that.addForm.createBy = util.session.get('user').id,
            that.addForm.entId = that.groupId
            myHttp.createInfoipad(this.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加角色成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
             that.addForm.updateBy = util.session.get('user').id,
            myHttp.updateInfoipad(this.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改角色成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // cancel() {
    //   this.addFormVisible = false
    //   this.editFormVisible = false
    // },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.addFormVisible = false
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done()
      //   })
      //   .catch(_ => {})
    },
  }
}
</script>

<style>
@import '../../assets/css/common.css';
</style>

<style scoped>
* {
  box-sizing: border-box;
}
.content {
  height: 100%;
  width: 100%;
  padding: 0 1vh;
}
.title{
    width: 100%;
    height: 3vh;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding-left: 1vw;
}
.build-CURD {
  width: 100%;
  height: calc( 100% - 3vh );
  position: relative;
  background: #fff;
}
.build-bar{
  padding: 0px 15px;
  height: 6vh;
  display: flex;
  align-items: center;
  justify-content: space-between
  /* border-bottom: 1px solid #ddd; */
}
.display{
 display: flex;
 justify-content: space-between;
 width: 30%;
 align-items: center;
}
.build-table {
  height: calc(100% - 15.5vh);
  padding: 0 1vh;
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
</style>

<style>
.add-form .el-select .el-input {
  width: 100%;
}
</style>